import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SButton, SContainer, SError, SFormControl } from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import Loading from "../../components/Loading/Loading";
import { te } from "../../utils/errorsTranslation";

const ProfilePage = () => {
  const { currentUser, logoutUser, changePassword, changeName, loading, error, resetError } = useContext(AuthContext);
  const history = useHistory();
  const { t } = useTranslation("", { keyPrefix: "auth.profile" });

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profileChangeError, setProfileChangeError] = useState("");

  useEffect(() => {
    if (currentUser) {
      setEmail(currentUser.email);
      setFirstName(currentUser.firstName);
      setLastName(currentUser.lastName);
    }
    return () => resetError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, error]);

  const onLogout = () => {
    logoutUser();
    history.push("/");
  };

  const onChangeUserInfo = (e) => {
    e.preventDefault();

    changeName(firstName, lastName).then((user) => {
      setFirstName(user.firstName);
      setLastName(user.lastName);
    });
  };

  const onChangePassword = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setProfileChangeError(t("different_passwords"));
    } else {
      changePassword(password, oldPassword).then((data) => {
        if (data) {
          setOldPassword("");
          setPassword("");
          setConfirmPassword("");
        }
      });
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer fluid fill="true" dark="true">
          <Row>
            <AppNavbar dark="true" />
          </Row>

          <Styles>
            <Container className="mt-5 pt-5">
              <Row className="mt-5 d-flex flex-row align-items-center">
                <Col className="me-5 pe-5">
                  <Form onSubmit={onChangeUserInfo}>
                    <div className="d-flex flex-row justify-content-between">
                      <h1 className="fw-bolder ms-2">{t("title")}</h1>
                      <SButton dark="true" className="fs-5 px-4" onClick={onLogout}>
                        {t("logout")}
                      </SButton>
                    </div>
                    <SFormControl className="fs-4 my-4 text-dark" type="email" defaultValue={email} disabled />
                    <SFormControl
                      className="fs-4 my-4"
                      type="text"
                      placeholder={t("first_name")}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    <SFormControl
                      className="fs-4 my-4"
                      type="text"
                      placeholder={t("last_name")}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    <SButton type="submit" dark="true" className="mt-4 w-100 fs-5">
                      {t("change_name")}
                    </SButton>
                  </Form>
                </Col>
                <Col className="d-flex flex-column flex-grow-1 mt-4 justify-content-end">
                  <Form onSubmit={onChangePassword}>
                    <SFormControl
                      className="fs-4 my-4"
                      type="password"
                      placeholder={t("old_password")}
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                    />
                    <SFormControl
                      className="fs-4 my-4"
                      type="password"
                      placeholder={t("new_password")}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <SFormControl
                      className="fs-4 my-4"
                      type="password"
                      placeholder={t("confirm_password")}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <SButton type="submit" dark="true" className="mt-4 w-100 fs-5">
                      {t("change_password")}
                    </SButton>
                  </Form>
                </Col>
              </Row>
              <Row>
                <Col>
                  {profileChangeError && <SError className="mt-3">{profileChangeError}</SError>}
                  {error && <SError className="mt-3">{te(error.message)}</SError>}
                </Col>
              </Row>
            </Container>
          </Styles>
        </SContainer>
      )}
    </>
  );
};

const Styles = styled.div`
  .container {
    color: var(--text-primary-dark) !important;

    textarea {
      display: flex;
      flex-grow: 1;
      width: 100%;
      height: 100%;
    }

    .col {
      height: 100%;
    }
  }
`;

export default ProfilePage;
